<template>

  <v-container style="padding:25px 0px 25px 0px;">
      <v-row class="text-center">
      <v-col cols="12" style="padding:0px 20px 0px 20px; margin:0px;">
        <v-select
          :items="sites"
          v-model="site"
          label="Select site"
          dense
          solo
          prepend-icon="mdi-map-marker-radius-outline"
        ></v-select>
      </v-col>
      </v-row>
      <v-row>
        
        <v-col cols="12" style="padding:0px 20px 0px 20px; margin:0px;">
          <v-card elevation="5">
          <div v-if="noData">    
            <v-alert  prominent outlined  border="left" type="warning" style="margin-top:16px" >
              There is no quicklook for this site.
            </v-alert>
          </div>
          <div v-else>
            <div v-for="(item, i) in hrefsPNG" :key="i">
              <a :href="'https://data.ipsl.fr/repository/ccres/monthly_report/'+item" target="_blank">
                <v-img :src="'https://data.ipsl.fr/repository/ccres/monthly_report/'+item" :title="item"></v-img>
              </a>
            </div>
          </div>
        </v-card>
        </v-col>
      </v-row>
    </v-container>
  
    
</template>

<script>
  import axios from 'axios';


  export default {
    name: 'ccres-visu-monthly',

    data: () => ({
      disdroURL: "https://data.ipsl.fr/repository/ccres/disdro/",
      ccresdata: null,
      site: "",
      sites: [],   
      noData: false,      
      loading: false,
      hrefsPNG: []
    }),
    created() {
    },
    mounted() {
      this.getCCRESConfig();
    },
    watch: {
      ccresdata: function (newVal, oldVal) {
        console.log('ccresdata:  '+newVal+' '+oldVal)
        for (let i = 0; i < this.ccresdata.length; i++) {
          this.sites.push( this.ccresdata[i].site)
        }
      },
      site: function (newVal, oldVal) {
        console.log('site:  ' + newVal+' '+oldVal)
        this.changeSite() 
      },
      loading: function (newVal, oldVal) {
        console.log('site:  ' + newVal+' '+oldVal)
        if(this.loading)
            document.body.style.cursor = 'wait'
        else
          document.body.style.cursor = 'default'
      }
    },
    methods: {
      changeSite() {
        console.log('changesite')
        this.hrefsPNG = []
        this.noData = false
        if(this.site != "") {
          axios
            .get('https://data.ipsl.fr/repository/ccres/monthly_report/')
            .then(response => {
              // Crée un élément temporaire pour parser le HTML
              const div = document.createElement('div');
              div.innerHTML = response.data;

              // Récupère tous les éléments <a> dans le contenu HTML
              const liens = div.querySelectorAll('a');
              
              // Extrait les attributs href de chaque lien et les met dans un tableau
              this.hrefsPNG = Array.from(liens)
                  .map(lien => lien.getAttribute('href'))
                  .filter(href => href && href.includes('.png') && href.includes(this.site))

                if (this.hrefsPNG.length == 0)
                  this.noData = true
            })
            .catch(error => {
              console.log(error)
            })
        }      
      },
      getCCRESConfig() {
        axios.get(this.disdroURL + "ccres_disdro_processing_conf.json").then(json => (this.ccresdata = json.data));            
      },
    }
  }
</script>
